export const styles = {
  modalClass: "!p-0 md:pr-11 flex p-0 flex-col !rounded-lg lg:!w-6/12 !w-full overflow-hidden",
  headerClass:
    "!mt-0 items-center text-white sticky h-20 pr-4 pl-[42%] bg-primary font-bold text-2xl",

  receiveLinkWrapper: "flex flex-col items-center px-8 py-8 md:px-12 md:py-10",
  receiveLinkTitle:
    "w-full max-w-lg text-center text-[18px] md:text-[20px] font-semibold text-[#282A30] leading-snug",
  linkActiveNote: "mt-3 text-[11px] font-normal text-[#949494]",
  linkSentMessage:
    "mt-4 text-[14px] md:text-[15px] w-full max-w-md text-center font-normal text-[#969696]",

  optionsRow:
    "mt-8 flex w-full max-w-xl flex-col items-stretch gap-4 sm:flex-row sm:justify-center sm:gap-6",
  optionButton:
    "flex min-h-[72px] min-w-[220px] flex-1 items-center justify-center gap-3 rounded-xl px-6 py-4 transition-colors disabled:cursor-not-allowed disabled:opacity-70",
  optionButtonDefault: "bg-[#F1F4FF] text-[#282A30] hover:bg-[#E8EEFF]",
  optionButtonActive: "bg-[#282A30] text-white",
  optionLabel: "text-[18px] md:text-[20px] font-medium whitespace-nowrap",

  doItLaterButton:
    "mt-10 flex items-center justify-center gap-3 text-primary font-semibold text-[18px] md:text-[20px] disabled:cursor-not-allowed disabled:opacity-70",
  errorWrapper: "mt-4 w-full max-w-md",

  awaitingWrapper: "flex flex-col items-center px-8 py-10 md:px-12",
  awaitingTitle: "text-center text-[15px] lg:text-[20px] text-primary font-semibold max-w-md",
  awaitingNote: "text-[15px] lg:text-[20px] font-semibold text-center",

  dotsWrapper: "flex space-x-2 animate-pulse my-8",
  dot: "w-3 h-3 bg-gray-500 rounded-full",

  resendBtn:
    "flex items-center justify-center gap-2 border border-primary bg-primary text-white font-semibold py-2 px-6 rounded-full text-[15px] lg:text-[20px] disabled:cursor-not-allowed disabled:opacity-60",

  signedWrapper: "flex flex-col items-center py-10 px-8",
  signedTitle: "text-[20px] lg:text-[25px] font-bold text-center",
  signedSubtitle: "text-[15px] lg:text-[20px] font-semibold text-center mb-4",
  signedLink: "cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold mt-3",
};
